"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPaymentFail = exports.checkPaymentSuccess = exports.checkPayment = exports.clearPaymentIntent = exports.clearPayment = exports.fetchPaymentIntentFailure = exports.fetchPaymentIntentSuccess = exports.fetchPaymentIntentRequest = exports.CHECK_PAYMENT_FAIL = exports.CHECK_PAYMENT_SUCCESS = exports.CHECK_PAYMENT = exports.PAYMENT_INTENT_CLEAR = exports.PAYMENT_CLEAR = exports.FETCH_PAYMENT_INTENT_FAILURE = exports.FETCH_PAYMENT_INTENT_SUCCESS = exports.FETCH_PAYMENT_INTENT_REQUEST = void 0;
exports.FETCH_PAYMENT_INTENT_REQUEST = 'payment/FETCH_PAYMENT_INTENT_REQUEST';
exports.FETCH_PAYMENT_INTENT_SUCCESS = 'payment/FETCH_PAYMENT_INTENT_SUCCESS';
exports.FETCH_PAYMENT_INTENT_FAILURE = 'payment/FETCH_PAYMENT_INTENT_FAILURE';
exports.PAYMENT_CLEAR = 'payment/CLEAR';
exports.PAYMENT_INTENT_CLEAR = 'payment/PAYMENT_INTENT_CLEAR';
exports.CHECK_PAYMENT = 'payment/check_payment';
exports.CHECK_PAYMENT_SUCCESS = 'payment/check_payment/success';
exports.CHECK_PAYMENT_FAIL = 'payment/check_payment/fail';
var fetchPaymentIntentRequest = function () { return ({ type: exports.FETCH_PAYMENT_INTENT_REQUEST }); };
exports.fetchPaymentIntentRequest = fetchPaymentIntentRequest;
var fetchPaymentIntentSuccess = function (data) { return ({ type: exports.FETCH_PAYMENT_INTENT_SUCCESS, data: data }); };
exports.fetchPaymentIntentSuccess = fetchPaymentIntentSuccess;
var fetchPaymentIntentFailure = function (e) { return ({ type: exports.FETCH_PAYMENT_INTENT_FAILURE, e: e }); };
exports.fetchPaymentIntentFailure = fetchPaymentIntentFailure;
var clearPayment = function () { return ({ type: exports.PAYMENT_CLEAR }); };
exports.clearPayment = clearPayment;
var clearPaymentIntent = function () { return ({ type: exports.PAYMENT_INTENT_CLEAR }); };
exports.clearPaymentIntent = clearPaymentIntent;
var checkPayment = function (key) { return ({ type: exports.CHECK_PAYMENT, key: key }); };
exports.checkPayment = checkPayment;
var checkPaymentSuccess = function (data) { return ({ type: exports.CHECK_PAYMENT_SUCCESS, data: data }); };
exports.checkPaymentSuccess = checkPaymentSuccess;
var checkPaymentFail = function () { return ({ type: exports.CHECK_PAYMENT_FAIL }); };
exports.checkPaymentFail = checkPaymentFail;
